import { DashboardRow, KpiStats } from "./types";

export function percent(value: number) {
  return `${(value * 100).toFixed(1)}%`;
}

export function formatNumber(value: number) {
  return new Intl.NumberFormat("en-US").format(value);
}

export function buildKpis(rows: DashboardRow[]): KpiStats {
  const totalApplications = rows.reduce((acc, row) => acc + row.applications, 0);
  const totalBeds = rows.reduce((acc, row) => acc + row.available_beds, 0);
  const totalAccepted = rows.reduce((acc, row) => acc + row.accepted_offers, 0);
  const totalOccupied = rows.reduce((acc, row) => acc + row.occupied_beds, 0);
  const totalWaitlist = rows.reduce((acc, row) => acc + row.waitlist_count, 0);
  const totalShortage = rows.reduce((acc, row) => acc + row.shortage, 0);

  const avgAcceptanceRate =
    totalApplications === 0 ? 0 : totalAccepted / totalApplications;
  const avgOccupancyRate =
    totalBeds === 0 ? 0 : totalOccupied / totalBeds;
  const avgWaitlistRate =
    totalApplications === 0 ? 0 : totalWaitlist / totalApplications;

  return {
    totalApplications,
    totalBeds,
    totalAccepted,
    totalOccupied,
    totalWaitlist,
    totalShortage,
    avgAcceptanceRate,
    avgOccupancyRate,
    avgWaitlistRate
  };
}

export function groupByTerm(rows: DashboardRow[]) {
  const map = new Map<
    string,
    {
      term_name: string;
      applications: number;
      available_beds: number;
      waitlist_count: number;
      shortage: number;
    }
  >();

  for (const row of rows) {
    const prev = map.get(row.term_name) ?? {
      term_name: row.term_name,
      applications: 0,
      available_beds: 0,
      waitlist_count: 0,
      shortage: 0
    };

    prev.applications += row.applications;
    prev.available_beds += row.available_beds;
    prev.waitlist_count += row.waitlist_count;
    prev.shortage += row.shortage;

    map.set(row.term_name, prev);
  }

  return Array.from(map.values());
}

export function groupByStudentType(rows: DashboardRow[]) {
  const map = new Map<
    string,
    {
      student_type_name: string;
      applications: number;
      available_beds: number;
      waitlist_count: number;
      shortage: number;
    }
  >();

  for (const row of rows) {
    const prev = map.get(row.student_type_name) ?? {
      student_type_name: row.student_type_name,
      applications: 0,
      available_beds: 0,
      waitlist_count: 0,
      shortage: 0
    };

    prev.applications += row.applications;
    prev.available_beds += row.available_beds;
    prev.waitlist_count += row.waitlist_count;
    prev.shortage += row.shortage;

    map.set(row.student_type_name, prev);
  }

  return Array.from(map.values()).sort((a, b) => b.shortage - a.shortage);
}
